export default {
  agency: {
    profile: {
      overview: '/dashboard/agency/{{agency_id}}/profile/overview',
      campaigns: {
        list: '/dashboard/agency/{{agency_id}}/profile/campaigns/list',
        yearly: '/dashboard/agency/{{agency_id}}/profile/campaigns/yearly',
      },
      clients: '/dashboard/agency/{{agency_id}}/profile/clients',
      users: '/dashboard/agency/{{agency_id}}/profile/users',
      invoices: '/dashboard/agency/{{agency_id}}/profile/invoices',
      reports: '/dashboard/agency/{{agency_id}}/profile/reports',
      invoice_history: '/dashboard/agency/{{agency_id}}/profile/invoice-history',
      invoice_details: '/dashboard/agency/{{agency_id}}/profile/invoice-details',
      accounts: '/dashboard/agency/{{agency_id}}/profile/accounts',
    },
  },
  dealership: {
    profile:
      '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/profile',
    audiences: {
      tag: '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/audiences/tag',
      programmatic:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/audiences/programmatic',
      custom:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/audiences/custom',
      report:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/audiences/programmatic/{{audience.platform_id}}/{{audience.id}}/data',
      create:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/audiences/custom/create/select-type',
      deploy:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/audiences/create/{audience._id}/deploy',
    },
    customers: {
      sources: {
        list: '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/customers/sources/list',
        create:
          '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/customers/sources/list/create',
        report:
          '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/customers/sources/{{source.id}}',
      },
      list: '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/customers/list',
    },
    campaigns: {
      list: '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/campaigns/list',
      create:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/campaigns/list/create/select',
      report:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/campaigns/{{campaign.product_code}}/{{campaign.client_campaign_id}}?startDate={{campaign.start_date}}&endDate={{campaign.end_date}}',
      'self-service': {
        list: '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/campaigns/self-service/list',
        report:
          '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/campaigns/self-service/{{campaign._id}}',
      },
    },
    reports: {
      summary:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/reports/summary',
      ga4: '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/performance/ga4',
      conversion_path:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/reports/conversion-paths',
      sale_path:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/reports/sale-paths',
      verified_sales:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/reports/verified-sales',
      creatives:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/reports/creatives',
      conversions:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/reports/conversion',
    },
    vehicles: {
      overview:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/inventory/overview',
      list: '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/inventory/list',
      marketed:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/inventory/marketed',
      sold: '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/inventory/sold-vehicles',
      vehicle:
        '/dashboard/agency/{{dealership.organization_id}}/{{dealership.industry, industry}}/{{dealership.id}}/inventory/vehicles/{{vehicle.vin}}',
    },
  },
  admin: {},
}
